<template>
<page
  title='Profile'
  :sub-title='pageTitle'
  :with-reload='false'
  :extension='true'
  :crumbs="crumbs"
  @refresh='touch++' >
  <template slot='toolbar' >
    <v-spacer></v-spacer>
    <v-btn text
      v-for='tab in tabs'
      :to='`/settings/me/${tab.id}`'
      :key='tab.id' >{{ tab.title }}</v-btn>
  </template>
  <v-tabs-items class='grey lighten-3' v-model='activeTab' >
    <v-tab-item v-for='tab in tabs' :key='tab.title' >
      <component
        v-if='tab.component'
        :is="tab.component"
        :touch='touch'
        v-bind='tab.attrs'
        class='pb-4' >
      </component>
      <v-card v-else>
        <v-card-title class='subtitle-1 overline' >
          {{tab.title}} coming soon ...
        </v-card-title>
        <v-card-text>
        </v-card-text>
      </v-card>
    </v-tab-item>
  </v-tabs-items>
</page>
</template>
<script>
import Profile from './Profile.vue'
import Rules from './Rules'
import Notifications from './Notifications'
import OperatingHours from './OperatingHours'
import Page from '@/components/layouts/Page.vue'
import PractitionerAppointmentTypes from './PractitionerAppointmentTypes.vue'

const TAB_INDEX = {
  'profile': 0,
  'appointment-types': 1,
  'rules': 2,
  'hours': 3,
  'notifications': 4,
}

export default {
  name: 'ProfileHome',
  components: {Page},
  props: {
    page: { type: String, default: 'profile' }
  },
  data () {
    return {
      activeTab: 0,
      touch: 0
    }
  },
  watch: {
    page: {
      immediate: true,
      handler () {
        if (this.page) {
          this.activeTab = TAB_INDEX[this.page]
        } else {
          this.activeTab = 0
        }
      }
    }
  },
  computed: {
    activePage () {
      return this.tabs[this.activeTab]
    },
    pageTitle () {
      if (this.activePage && this.activePage.title) {
        return this.activePage.title
      }
      return ''
    },
    tabs () {
      return [
        {
          id: 'profile',
          title: 'Profile',
          component: Profile,
          attrs: { }
        },
        {
          id: 'appointment-types',
          title: 'Appointment Types',
          component: PractitionerAppointmentTypes,
          attrs: { }
        },
        {
          id: 'rules',
          title: 'Rules',
          component: Rules,
          attrs: { }
        },
        {
          id: 'hours',
          title: 'Hours',
          component: OperatingHours,
          attrs: { }
        },
        {
          id: 'notifications',
          title: 'Notifications',
          component: Notifications,
          attrs: { }
        }
      ]
    },
    crumbs () {
      let crumbs = [
        {text: 'Home', to: '/'}
      ]
      if (this.activePage) {
        if (this.activePage.title !== 'Profile') {
          crumbs.push({text: 'Profile', to: '/settings/me/', exact: true})
        }
        crumbs.push({text: this.activePage.title})
      }
      return crumbs
    }
  }
}
</script>